import { Box, Tabs, Tab, TabList } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

// Constants
const tabIndexes = {
  'outstanding-ledger': 0,
  'expenses-fees': 1,
  'monthly-summary': 2,
};

// Exports
type Props = {
  children: React.ReactChild | React.ReactChild[];
  selectedTab: 'outstanding-ledger' | 'expenses-fees' | 'monthly-summary';
};
export const StatementsTemplate = ({ children, selectedTab }: Props) => {
  const navigate = useNavigate();
  const flags = useFeatureFlags();
  return (
    <>
      <Tabs variant="line" index={tabIndexes[selectedTab]} colorScheme="black">
        <TabList>
          <Tab onClick={() => navigate('/statements/outstanding-ledger')}>
            Outstanding Ledger
          </Tab>
          <Tab onClick={() => navigate('/statements/expenses-fees')}>
            Expenses &amp; Fees
          </Tab>
          {flags?.isStatementsMonthlySummaryEnabled && (
            <Tab onClick={() => navigate('/statements/monthly-summary')}>
              Monthly Summary
            </Tab>
          )}
        </TabList>
      </Tabs>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
